/**
 * Feature Routes - Barrel export
 *
 * Aggregates all feature route configs into a single array.
 * Each feature exports its own RouteConfig[] matching legacy app guard combinations.
 */

export { authRoutes } from './auth/authRoutes';
export { headRoutes } from './head/headRoutes';

export { myInsightsRoutes } from './my-insights/myInsightsRoutes';
export { overviewPageRoutes } from './overview-page/overviewPageRoutes';
export { scorecardRoutes } from './scorecard/scorecardRoutes';
export { providerBriefingRoutes } from './provider-briefing/providerBriefingRoutes';
export { providerExperienceRoutes } from './provider-experience/providerExperienceRoutes';
export { pemDetailsRoutes } from './pem-summary/pemSummaryRoutes';
export { surestRoutes } from './surest/surestRoutes';
export { aigenieRoutes } from './aigenie/aigenieRoutes';
export { patientCareOpportunityRoutes } from './patient-care-opportunity/patientCareOpportunityRoutes';
export { medicalCostRoutes } from './medical-cost/medicalCostRoutes';
export { jarvisdashboardsRoutes } from './jarvisdashboards/jarvisdashboardsRoutes';
export { contentEditorRoutes } from './content-editor/contentEditorRoutes';
export { psmsRoutes } from './psms/psmsRoutes';
export { pcorRoutes } from './pcor/pcorRoutes';
export { ancillaryRoutes } from './ancillary/ancillaryRoutes';
export { acoRoutes } from './aco/acoRoutes';
export { adminSummaryTrendsRoutes } from './admin-summary-trends/adminSummaryTrendsRoutes';
export { serviceInteractionRoutes } from './service-interaction/serviceInteractionRoutes';
export { priorAuthRoutes } from './prior-auth/priorAuthRoutes';
export { reimbursementsRoutes } from './reimbursements/reimbursementsRoutes';
export { networkManagementRoutes } from './network-management/networkManagementRoutes';
export { healthSystemDetailsRoutes } from './health-system-details/healthSystemDetailsRoutes';
export { overviewPageAdvocateRoutes } from './overview-page-advocate/overviewPageAdvocateRoutes';
export { contractIdDetailsRoutes } from './contract-id-details/contractIdDetailsRoutes';

import { RouteConfig } from '../types';
import { myInsightsRoutes } from './my-insights/myInsightsRoutes';
import { overviewPageRoutes } from './overview-page/overviewPageRoutes';
import { scorecardRoutes } from './scorecard/scorecardRoutes';
import { providerBriefingRoutes } from './provider-briefing/providerBriefingRoutes';
import { providerExperienceRoutes } from './provider-experience/providerExperienceRoutes';
import { pemDetailsRoutes } from './pem-summary/pemSummaryRoutes';
import { surestRoutes } from './surest/surestRoutes';
import { aigenieRoutes } from './aigenie/aigenieRoutes';
import { patientCareOpportunityRoutes } from './patient-care-opportunity/patientCareOpportunityRoutes';
import { medicalCostRoutes } from './medical-cost/medicalCostRoutes';
import { jarvisdashboardsRoutes } from './jarvisdashboards/jarvisdashboardsRoutes';
import { contentEditorRoutes } from './content-editor/contentEditorRoutes';
import { psmsRoutes } from './psms/psmsRoutes';
import { pcorRoutes } from './pcor/pcorRoutes';
import { ancillaryRoutes } from './ancillary/ancillaryRoutes';
import { acoRoutes } from './aco/acoRoutes';
import { adminSummaryTrendsRoutes } from './admin-summary-trends/adminSummaryTrendsRoutes';
import { serviceInteractionRoutes } from './service-interaction/serviceInteractionRoutes';
import { priorAuthRoutes } from './prior-auth/priorAuthRoutes';
import { reimbursementsRoutes } from './reimbursements/reimbursementsRoutes';
import { networkManagementRoutes } from './network-management/networkManagementRoutes';
import { healthSystemDetailsRoutes } from './health-system-details/healthSystemDetailsRoutes';
import { overviewPageAdvocateRoutes } from './overview-page-advocate/overviewPageAdvocateRoutes';
import { contractIdDetailsRoutes } from './contract-id-details/contractIdDetailsRoutes';

/**
 * All feature routes combined.
 * Used by Routes.tsx to render guarded routes.
 */
export const featureRoutes: RouteConfig[] = [
  ...myInsightsRoutes,
  ...overviewPageRoutes,
  ...scorecardRoutes,
  ...providerBriefingRoutes,
  ...providerExperienceRoutes,
  ...pemDetailsRoutes,
  ...surestRoutes,
  ...aigenieRoutes,
  ...patientCareOpportunityRoutes,
  ...medicalCostRoutes,
  ...jarvisdashboardsRoutes,
  ...contentEditorRoutes,
  ...psmsRoutes,
  ...pcorRoutes,
  ...ancillaryRoutes,
  ...acoRoutes,
  ...adminSummaryTrendsRoutes,
  ...serviceInteractionRoutes,
  ...priorAuthRoutes,
  ...reimbursementsRoutes,
  ...networkManagementRoutes,
  ...healthSystemDetailsRoutes,
  ...overviewPageAdvocateRoutes,
  ...contractIdDetailsRoutes,
];
